import { render, staticRenderFns } from "./TreeTable.vue?vue&type=template&id=1ef061d3&scoped=true"
import script from "./TreeTable.vue?vue&type=script&lang=js"
export * from "./TreeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef061d3",
  null
  
)

export default component.exports